<template><svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path :d="drawing" /></svg></template>
<script>
const paths={
 'bi-person':'M20 21v-2a7 7 0 0 0-14 0v2 M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0',
 'bi-bell':'M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4',
 'bi-grid':'M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z',
 'bi-grid-1x2':'M3 3h7v18H3z M14 3h7v7h-7z M14 14h7v7h-7z',
 'bi-file-earmark-bar-graph':'M14 2H4v20h16V8z M14 2v6h6 M8 17v-3 M12 17v-6 M16 17v-2',
 'bi-arrow-down-up':'M7 20V4 M3 8l4-4 4 4 M17 4v16 M13 16l4 4 4-4',
 'bi-wallet':'M3 6V4h16v3 M3 7h18v14H3z M21 11h-6v6h6 M17 14h.01',
 'bi-cash-stack':'M2 7h20v13H2z M5 3h14 M12 10a3 3 0 1 0 0 6 3 3 0 0 0 0-6 M5 13h.01 M19 13h.01',
 'bi-bag-check':'M4 7h16l1 15H3z M8 7V5a4 4 0 0 1 8 0v2 M8 14l3 3 5-5',
 'bi-megaphone':'M3 10h5l12-6v16L8 14H3z M8 14l2 7H6l-2-7',
 'bi-stars':'M12 2l3 7 7 3-7 3-3 7-3-7-7-3 7-3z',
 'bi-credit-card-2-front':'M3 4h18v16H3z M3 9h18 M7 15h4',
 'bi-headset':'M3 14v-3a9 9 0 0 1 18 0v3 M3 12h3v7H3z M18 12h3v7h-3z M21 19c0 3-3 3-7 3',
 'bi-box-arrow-right':'M10 3H3v18h7 M8 12h14 M17 7l5 5-5 5',
 'bi-x-lg':'M6 6l12 12 M6 18L18 6'
};paths['bi-wallet2']=paths['bi-wallet'];
export default {props:{name:String},computed:{drawing(){return paths[(this.name||'').split(' ').find(x=>paths[x])]||paths['bi-grid'];}}};
</script>